import apiClient from "../../utils/api.client";
import FileSaver from "file-saver";


export const getAgencieReport = async (agencie, date, subagency) => {
  try {
    
    const response = await apiClient.get(
      // gammagw-dev.tecnoaccion.com.ar/settlements/1/report/imputation?organizationId=1&orderCriteria=ASC&agencyId=252&status=SETTLED

      `/gamma-movements/settlements/agencies/${agencie?.id}/report?settlementDate=${date}&pageSize=10000000&movementSize=10000000${subagency && agencie?.id !== subagency?.id ? `&agencyIds=${subagency?.id}` : ""}`,
    );
    const data = response.data;

    return data;
  } catch (error) {
    console.error("Error at getAgencieReport EP: ", error);
    if (error instanceof Error) {
      throw error;
    } else {
      throw new Error("Error at getAgencieReport EP: ", error);
    }
  }
};

export const getSettlementReport = async (organizationId, agencySettlementId, includeBarcode = false, includeTalon = false) => {
  try {
    const response = await apiClient.get(
      `/gamma-movements/organizations/${organizationId}/agencySettlements/pdf?agencySettlementId=${agencySettlementId}&includeBarcode=${includeBarcode}&includeTalon=${includeTalon}`,
      {
        responseType: "blob",
        headers: {
          Accept: "application/pdf",
        },
      },
    );
    const data = response.data;

    return data;
  } catch (error) {
    console.error("Error at getAgencieReport EP: ", error);
    if (error instanceof Error) {
      throw error;
    } else {
      throw new Error("Error at getAgencieReport EP: ", error);
    }
  }
};
